import React, { useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Ad from 'models/business/Ad';
import ButtonSwitch from 'components/Common/ButtonSwitch';
import EmptyBar from 'components/Common/EmptyBar';
import Select from 'components/Common/Select';
import ClickableDiv from 'components/Common/ClickableDiv';
import { Categories as ProductCategories } from 'models/business/Product';
import inputFormat from 'tools/inputFormat';
import Styles from './index.module.css';

const toBooleanString = (b) => (b ? '開啟' : '關閉');

function EndAdornmentInput({
  onChange,
  value,
}) {
  const inputRef = useRef(null);
  useEffect(() => {
    // eslint-disable-next-line no-new
    // eslint-disable-next-line no-unused-vars
    inputFormat(inputRef.current);
  }, []);
  return (
    <div
      className={Styles.inputEndAdornmentContent}
    >
      <div style={{
        flex: 2,
      }}
      >
        <input
          ref={inputRef}
          type="text"
          onChange={onChange}
          value={value}
          className={Styles.textInput}
        />
      </div>
      <div
        style={{
          flex: 1,
        }}
        className={Styles.inputEndAdornmentTextContainer}
      >
        <div className={Styles.inputEndAdornmentText}>
          元
        </div>
      </div>
    </div>
  );
}

EndAdornmentInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

EndAdornmentInput.defaultProps = {
  onChange: () => {},
  value: '',
};

function TargetSetting({
  ad,
  onChangeAd,
  active,
  onSetActive,
  disabled,
}) {
  const handleChangeField = (e, field) => {
    const newAd = ad.clone();
    newAd[field] = e.target.value;
    onChangeAd(newAd);
  };
  // const [price, setPrice] = useState(45);
  // const [productCategory, setProductCategory] = useState('');
  // const [commodityBuyer, setCommodityBuyer] = useState('關閉');
  // const [commodityInCart, setCommodityInCart] = useState('關閉');
  // const [interestingInSameType, setInterestingInSameType] = useState('關閉');

  // const handleChangePrice = (e) => {
  //   handleChangeField({ target: { value: e.target.value.replace(/[^0-9]/g, '') } },
  //     'averagePricePerCustomer');
  // };

  const renderSettingForm = useMemo(() => (
    <>
      <div
        style={{
          flex: 3,
        }}
      >
        <div
          className={Styles.title}
        >
          HHG Ads 受眾資料庫，幫您找到最適合的受眾
        </div>
        <div
          className={Styles.blockContainer}
          style={{
            paddingBottom: '24px',
          }}
        >
          {/* <div
            className={Styles.blockItem}
            style={{
              marginRight: '18px',
            }}
          >
            <div
              className={Styles.subTitle1}
              style={{
                paddingBottom: '9px',
                flex: 1,
              }}
            >
              均客單價
            </div>
            <EndAdornmentInput value={ad.averagePricePerCustomer} onChange={handleChangePrice} />
            <div className={Styles.subTitle2}>
              請提供您賣場中所有訂單的「平均客單價」
            </div>
          </div> */}
          <div
            className={Styles.blockItem}
          >
            <div
              className={Styles.subTitle1}
              style={{
                paddingBottom: '9px',
                flex: 1,
              }}
            >
              投放商品品類
            </div>
            <div style={{ width: '100%', flex: 2, backgroundColor: '#eaf0ff' }}>
              <Select
                style={{ width: '100%', height: '100%' }}
                value={ad.productCategory}
                options={Object.values(ProductCategories)}
                onChange={(e) => handleChangeField(e, 'productCategory')}
              />
            </div>
            <div className={Styles.subTitle2}>　</div>
          </div>
        </div>
        <div>
          <div
            className={Styles.subTitle1}
          >
            投放對象
          </div>
        </div>
        <div
          className={Styles.blockContainer}
        >
          <div
            className={Styles.blockItem}
            style={{
              marginRight: '18px',
            }}
          >
            <div
              className={Styles.subTitle2}
            >
              買過商品的人
            </div>
            <ButtonSwitch value={ad.toBought} onChange={(value) => handleChangeField({ target: { value } }, 'toBought')} />
          </div>
          <div
            className={Styles.blockItem}
            style={{
              marginRight: '18px',
            }}
          >
            <div
              className={Styles.subTitle2}
            >
              將您的商品加入購物車的人
            </div>
            <ButtonSwitch value={ad.toAddedCart} onChange={(value) => handleChangeField({ target: { value } }, 'toAddedCart')} />
          </div>
          <div
            className={Styles.blockItem}
          >
            <div
              className={Styles.subTitle2}
            >
              對同屬性商品有興趣的人
            </div>
            <ButtonSwitch value={ad.toSameType} onChange={(value) => handleChangeField({ target: { value } }, 'toSameType')} />
          </div>
        </div>
      </div>
      <div
        className={Styles.emptyColumn}
        style={{
          flex: 1,
        }}
      />
    </>
  ), [active, ad]);

  const renderResult = useMemo(() => (
    <>
      <div
        className={Styles.blockContainer}
        style={{
          marginBottom: '14px',
        }}
      >
        {/* <div
          className={Styles.blockContainer}
          style={{
            flex: 1,
          }}
        >
          <div
            className={Styles.resultTitle}
          >
            均客單價:
          </div>
          <div className={Styles.resultContent}>
            {ad.averagePricePerCustomer}
            元
          </div>
        </div> */}
        <div
          className={Styles.blockContainer}
          style={{
            flex: 1,
          }}
        >
          <div
            className={Styles.resultTitle}
          >
            投放商品品類:
          </div>
          <div className={Styles.resultContent}>{ad.productCategory}</div>
        </div>
        <div
          style={{
            flex: 2,
          }}
        />
      </div>
      <div
        className={Styles.blockContainer}
      >
        <div
          className={Styles.blockItem}
        >
          <div className={Styles.resultTitle}>投放對象</div>
        </div>
        <div
          className={Styles.blockItem}
        >
          <div className={Styles.resultTitle}>買過商品的人:</div>
          <div className={Styles.resultContent}>{toBooleanString(ad.toBought)}</div>
        </div>
        <div
          className={Styles.blockItem}
        >
          <div className={Styles.resultTitle}>將您的商品加入購物車的人:</div>
          <div className={Styles.resultContent}>{toBooleanString(ad.toAddedCart)}</div>
        </div>
        <div
          className={Styles.blockItem}
        >
          <div className={Styles.resultTitle}>對同屬性商品有興趣的人:</div>
          <div className={Styles.resultContent}>{toBooleanString(ad.toSameType)}</div>
        </div>
      </div>
    </>
  ), [active, ad]);

  return (
    <div className={classNames(Styles.mainContainer, { [Styles.mainContainerExpanded]: active })}>
      <div className={classNames(Styles.titleText, { [Styles.titleTextInactive]: !active })}>
        受眾設定
      </div>
      {disabled && <EmptyBar />}
      {(active || (!disabled && !active)) && (
        <ClickableDiv
          className={classNames(
            Styles.innerWrapperResult,
            { [Styles.innerWrapperSetting]: active },
          )}
          onClick={active ? () => {} : onSetActive}
        >
          {active && renderSettingForm}
          {!disabled && !active && renderResult}
        </ClickableDiv>
      )}
    </div>
  );
}

TargetSetting.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  active: PropTypes.bool,
  onSetActive: PropTypes.func,
  disabled: PropTypes.bool,
};

TargetSetting.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  active: false,
  onSetActive: () => {},
  disabled: true,
};

export default TargetSetting;
